import { computed, ComputedRef } from "vue";
import { toast } from "vue-sonner";
import { RecordInfo } from "@/types/entry.ts";
import { useStore } from "vuex";
import { useRouter } from "vue-router";

export const key = Symbol("addRecordItemButton");

export interface AddRecordItemButtonApi {
  show: ComputedRef<boolean>;
  onClick: (id: string) => Promise<void>;
}

export default function createData(): AddRecordItemButtonApi {
  const store = useStore();
  const router = useRouter();
  return {
    show: computed(
      () =>
        store.getters.showCMS ||
        router.currentRoute.value.name === "BulkRecordItemsEditor"
    ),
    onClick: async (id) => {
      const recordColumns = JSON.parse(
        JSON.stringify(
          store.getters.getStoreVar(
            "Category",
            "page",
            "recordColumns",
            "recordColumns"
          )
        )
      );
      const column = recordColumns.find((c: RecordInfo) => c.columnID === id);
      const newRecord = {
        name: "New Record",
        recordValue: "",
        recordDate: "",
        yearStart: "",
        yearEnd: "",
        primaryInfo: "",
        extraInfo: "",
        description: "",
        recordImage: [],
        columnID: column.columnID,
      };

      const { categoryID } = store.state.route.params;

      const doc = {
        categoryID,
        recordInfo: newRecord,
      };

      const res = await store.dispatch("api/addEntry", {
        doc,
        categoryID,
      });
      if (res.status !== 201) {
        toast.error("Error creating new record");
      }
    },
  };
}

const injectError = `Inject has failed for AddRecordItemButtonApi`;

export const defaultApi: AddRecordItemButtonApi = {
  show: computed(() => false),
  onClick: async () => console.error(injectError),
};

export const storybookApi: AddRecordItemButtonApi = {
  show: computed(() => false),
  onClick: async (id) => alert(`adding record to record column with id: ${id}`),
};
